import { TokenLogout } from 'API/Logout/logout';
import axios from 'axios';

const url = process.env.REACT_APP_BACKEND_URL;

export const GetListForTm = async (filter, page, setData, handleAlertOpen, setIsLoading) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url}/ds/gm/updated/list`,
        { ...filter },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          },
          params: {
            page,
            limit: 10
          }
        }
      )
      .then((response) => {
        setData(response.data);
        setIsLoading(false);
        // handleAlertOpen(true, "Data fetched successfully");
      });
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
    TokenLogout(error);
  }
};

export const GeneratePaymentLink = async (data, setIsLoading, handleAlertOpen, handleClose, handleGet) => {
  try {
    setIsLoading(true);
    await axios
      .post(`${url}/ds/payment/link`, data, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          Profile: 'finvesta_FIN001'
        }
      })
      .then((response) => {
        setIsLoading(false);
        handleAlertOpen(response.data.message ? response.data.message : 'Payment Link generated successfully', 'success');
        handleClose();
        handleGet();
      });
  } catch (error) {
    console.log('error', error);

    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
    TokenLogout(error);
  }
};

export const GetPaymentStatus = async (id, setIsLoading, handleAlertOpen) => {
  console.log('id', id);

  try {
    setIsLoading(true);
    await axios
      .post(
        `${url}/ds/payment/status`,
        { user_id: id },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((response) => {
        setIsLoading(false);
        handleAlertOpen(response.data.message ? response.data.message : `Order status: ${response.data['Order status']}`, 'success');
      });
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
    TokenLogout(error);
  }
};
